import $ from 'jquery'
$(document).ready( initMainSlider )

function initMainSlider(){
  if ($('.js-slider').length) {
    console.log('initMainSlider')
    $('.js-slider').slick({
      arrows: true,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"></button>',
    });
  }
}
